export const SIDEBAR_STORAGE_KEYS = {
	collapsed: 'suigar.sidebar.collapsed',
	expanded: 'suigar.sidebar.expanded',
} as const;

const DEFAULT_EXPANDED_CATEGORIES = ['Games'] as const;

export function readSidebarCollapsedFromStorage(): boolean {
	if (typeof window === 'undefined') return false;
	try {
		return window.localStorage.getItem(SIDEBAR_STORAGE_KEYS.collapsed) === 'true';
	} catch {
		return false;
	}
}

export function writeSidebarCollapsedToStorage(collapsed: boolean): void {
	if (typeof window === 'undefined') return;
	try {
		window.localStorage.setItem(SIDEBAR_STORAGE_KEYS.collapsed, String(collapsed));
	} catch {
		// best-effort persistence
	}
}

export function readSidebarExpandedCategoriesFromStorage(): Set<string> {
	const fallback = new Set<string>(DEFAULT_EXPANDED_CATEGORIES);
	if (typeof window === 'undefined') return fallback;

	try {
		const stored = window.localStorage.getItem(SIDEBAR_STORAGE_KEYS.expanded);
		if (!stored) return fallback;

		const parsed: unknown = JSON.parse(stored);
		if (!Array.isArray(parsed)) return fallback;

		const categories = parsed.filter((value): value is string => typeof value === 'string' && value.length > 0);
		if (parsed.length > 0 && categories.length === 0) {
			return fallback;
		}
		return new Set(categories);
	} catch {
		return fallback;
	}
}

export function writeSidebarExpandedCategoriesToStorage(expanded: Iterable<string>): void {
	if (typeof window === 'undefined') return;
	try {
		window.localStorage.setItem(SIDEBAR_STORAGE_KEYS.expanded, JSON.stringify(Array.from(expanded)));
	} catch {
		// best-effort persistence
	}
}
